/**
 * @author Ariel
 * @date 2020-08-25
 * @desc 应用服务列表页配置
 */
import React from 'react'
import {component_tool} from '../../../tool';
import {WizTableForm} from "../../common";

let {WizModal} = component_tool;
let componentName = 'applicationManage'

const organizationConfig = WizTableForm.Config.organization(this, {apiParams: {state: 1}})

const columns = [
  {
    name: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '名称',
    name: 'name',
    searchItem: {},
  },
  {
    title: '应用服务名称',
    name: 'name',
    tableItem: {},
  },
  {
    title: '编号',
    name: 'code',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '所属组织',
    name: 'orgName',
    tableItem: {},
  },
  {
    title: '来源',
    name: 'sourceType',
    searchItem: {type: 'select'},
    tableItem: {},
    dict: [
      {code: 0, codeName: '新培训平台'},
      {code: 1, codeName: '第三方系统'}
    ]
  },
  {
    title: '状态',
    name: 'status',
    tableItem: {},
    searchItem: {type: 'select'},
    dict: [
      {code: 0, codeName: '禁用'},
      {code: 1, codeName: '启用'}
    ]
  },
  {
    title: '所属组织',
    name: 'orgIds',
    searchItem: {
      ...organizationConfig,
      diy: WizTableForm,
      selectType: 'checkbox',
    },
  },
];

const templateConfig = (e) => {
  let { _btnFun } = e;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          buttonSort: ['add', 'columnApplicationManagement', 'export'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: {icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/application/applicationManage/applicationManageDetailAdd',
                }
              }
            },
            {
              key: 'columnApplicationManagement',
              name: 'WizButton',
              params: {
                children: '栏目应用管理',
                key: '_btn',
                type: 'primary',
              },
              onClick: (e) => _btnFun && _btnFun(e),
            },
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['look', 'update', 'enableOrDisable'],
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: {children: "查看"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/application/applicationManage/applicationManageLook"
              }
            }
          },
          {
            key: "update",
            custom: true,
            params: {children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/application/applicationManage/applicationManageDetailUpd"
              },
            }
          },
          {
            key: "enableOrDisable",
            custom: true,
            params: {children: "启用"},
            textFormat: {
              recordKey: 'status',
              dirt: {'1': '禁用', '0': '启用',}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['status'] === 0 ? "启用" : "禁用"
                }该应用服务吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      status: record['status'] === 0 ? 1 : 0,
                      id: record['id'],
                      ...filters
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          }
        ]
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
}

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
